import { createApiEndpoint } from '../api/createApiEndpoint.js';
import * as global from './global.js';

export const DEFAULT_HISTORY_TIME_OF_DAY = '04:00:00';

/** Normalize "H:mm", "HH:mm", or "HH:mm:ss" to "HH:mm:ss". */
export function normalizeTimeOfDayHms(value) {
    if (typeof value !== 'string' || !value.trim()) return DEFAULT_HISTORY_TIME_OF_DAY;
    const parts = value.trim().split(':');
    if (parts.length < 2) return DEFAULT_HISTORY_TIME_OF_DAY;
    const h = String(parseInt(parts[0], 10) || 0).padStart(2, '0');
    const m = String(parseInt(parts[1], 10) || 0).padStart(2, '0');
    const s = String(parseInt(parts[2] ?? '0', 10) || 0).padStart(2, '0');
    return `${h}:${m}:${s}`;
}

/** Same field Comparison uses: Task.RunAt for forDate's weekday (first autoscan of that day). */
export function taskTimeHmsFromApiRow(row) {
    if (!row || typeof row !== 'object') return null;
    const raw = row.taskTimeHms ?? row.TaskTimeHms;
    if (typeof raw !== 'string' || !/^\d{1,2}:\d{2}/.test(raw.trim())) return null;
    return normalizeTimeOfDayHms(raw);
}

/**
 * Apply Dates / history-slider default time: first Task.RunAt autoscan on forDate's weekday
 * (same source as Comparison's target time). Cached per site + weekday.
 */
export async function resolveDefaultHistoryTimeOfDay(siteGuid, forDate) {
    const site = global.gw?.selectedSite;
    const guid = siteGuid ?? site?.siteGuid;
    const dt = forDate instanceof Date && !Number.isNaN(forDate.getTime()) ? forDate : new Date();
    if (!guid || !global.gw?.email) {
        return DEFAULT_HISTORY_TIME_OF_DAY;
    }
    const cacheKey = `${guid}:${dt.getDay()}`;
    if (site?.siteGuid === guid && site.historyTimeOfDay && site.historyTimeOfDayCacheKey === cacheKey) {
        return site.historyTimeOfDay;
    }

    try {
        const output = global.gw.bolts ? 'compressed' : 'direct';
        const res = await createApiEndpoint().fetchSiteComparisonFormDefaults(output, guid, dt, false);
        if (res === false || res?.errors?.length) {
            return DEFAULT_HISTORY_TIME_OF_DAY;
        }
        const row = res?.data?.fetchSiteComparisonFormDefaults;
        const hms = taskTimeHmsFromApiRow(row) ?? DEFAULT_HISTORY_TIME_OF_DAY;
        if (site?.siteGuid === guid) {
            site.historyTimeOfDay = hms;
            site.historyTimeOfDayCacheKey = cacheKey;
            window.dispatchEvent(new CustomEvent('historyTimeOfDayUpdated', { detail: { timeOfDay: hms } }));
        }
        return hms;
    } catch {
        return DEFAULT_HISTORY_TIME_OF_DAY;
    }
}
